/**
 * CONFIGURACIÓN DE DIRECCIONES DE CONTRATOS
 * 
 * ¡ACTUALIZA ESTE ARCHIVO CUANDO DESPLIEGUES NUEVOS CONTRATOS!
 * Solo necesitas modificar las direcciones y el resto de la app se actualizará.
 */

// ======================================================================
// INTERRUPTOR DE MODO DE PRUEBA - CAMBIAR AQUÍ PARA ALTERNAR ENTRE REDES
// ======================================================================
// - TRUE: Usa contratos en BSC Testnet y trata BSC Testnet como red válida
// - FALSE: Usa contratos en BSC Mainnet y requiere BSC Mainnet para operar
export const IS_TEST_MODE = false; // Cambiar de true a false para usar Mainnet

// Direcciones de contratos por red
const TESTNET_ADDRESSES = {
  token: "0x7eC2dCC008CA6037605D1E53E482ca7D741adAC6", // Token en BSC Testnet
  presale: "0x1E06711a398232346D402654CDedC16fEF962477", // Presale en BSC Testnet
  staking: "0x81E3564B604a6b30F3ca573f777d97B0b396D0da", // Staking en BSC Testnet
  vesting: "0x39AfE12d9D1D4BB68c99FbF25c4620078BdDf89e", // Vesting en BSC Testnet
  usdt: "0x677C2Cb5fc37020185B84d9daE315D39f7b7d62A" // USDT en BSC Testnet
};

const MAINNET_ADDRESSES = {
  token: "0xa0172c16769484543d998739d002f81F5387AA7B", // Token en BSC Mainnet
  presale: "0x8020471206741a77F78E071b25F4C92d08e253e2", // Presale en BSC Mainnet
  staking: "0xFdfc00Aa8395e3380Ee1b6f304a070B81F625f50", // Staking en BSC Mainnet
  vesting: "0xEaf07443A15c25C706a6f2392a2686F1b98d18BB", // Vesting en BSC Mainnet
  usdt: "0x55d398326f99059fF775485246999027B3197955" // USDT en BSC Mainnet
};

// Exportar TESTNET_ADDRESSES y MAINNET_ADDRESSES para poder usarlos directamente
export { TESTNET_ADDRESSES, MAINNET_ADDRESSES };

// Exportar las direcciones correctas según el modo seleccionado
export const CONTRACT_ADDRESSES = IS_TEST_MODE ? TESTNET_ADDRESSES : MAINNET_ADDRESSES;

// Metadatos del token - versión simplificada solo con lo esencial
export const TOKEN_METADATA = {
  name: "eDOP Token", // Nombre en el contrato
  symbol: "eDOP",
  decimals: 18,
  logoURI: "https://www.edoptoken.com/logos/logo-edop-token.svg" // URL absoluta para acceso desde cualquier lugar
};

// Información de redes soportadas
export const SUPPORTED_CHAINS = {
  bsc: {
    chainId: 56,
    name: "BNB Smart Chain",
    rpcUrl: "https://bsc-dataseed.binance.org/",
    symbol: "BNB",
    explorerUrl: "https://bscscan.com/",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18
    }
  },
  bscTestnet: {
    chainId: 97,
    name: "BSC Testnet",
    rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545/",
    symbol: "BNB",
    explorerUrl: "https://testnet.bscscan.com/",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18
    }
  }
  // Añadir otras redes según sea necesario
};

// Red predeterminada según el modo seleccionado
export const DEFAULT_CHAIN = IS_TEST_MODE ? "bscTestnet" : "bsc";

// Lista de chainIds válidos para la app (se usa para validaciones)
export const VALID_CHAIN_IDS = IS_TEST_MODE ? [97] : [56];
